import type {ExtractPropsWithoutRef} from '@/types';

import styled from '@emotion/styled';
import {HelpTooltip as Help} from '@travel-frontend/ui-components';

type Props = ExtractPropsWithoutRef<typeof Help> & {
  onClick?: React.MouseEventHandler;
  className?: string;
  style?: React.CSSProperties;
};

export const HelpTooltip = styled(({onClick, ...restProps}: Props) => {
  return (
    <Help
      {...restProps}
      // @ts-expect-error ...
      onClick={(event: React.MouseEvent) => {
        // When embedding a HelpTooltip within another clickable element, the parent handlers should not be triggered. Only the Tooltip should open.
        event.preventDefault();
        onClick?.(event);
      }}
    />
  );
})<Props>`
  position: relative;
  cursor: default;

  &:after {
    content: '';
    position: absolute;
    inset: -5px;
  }
`;
